export enum AdminAddPharmacyFormItemName {
  Name = "name",
  Adress = "adress",
  PhoneNumber = "phoneNumber",
  Email = "email",
}
